import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import repAPI from '../../sources/api/repAPI';

// constants
import { REP_LIST_FETCH } from '../../constants/repTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { repListSchema } from '../../schemas/Normalizr';

export function* repListFetch(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  try {
    yield *httpSaga(REP_LIST_FETCH, call(repAPI.all), repListSchema);
  } catch (e) {
    yield put(error(REP_LIST_FETCH, e));
  } finally {
    yield put(doneIndicator(REP_LIST_FETCH));
  }
}

export function* watchRepListFetch() {
  yield takeEvery(REP_LIST_FETCH, repListFetch);
}

export default function* root() {
  yield all([
    fork(watchRepListFetch)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/rep/repListFetch.js